import React from 'react'
import { IWizardStepContext, StepName } from '../types'
import { notYetImplementedWithError } from '../../../utils'
import { ITime } from '../../../utils/time';
import { Timezone, Weekday } from '../../../apilibrary/types/common';
import { ComponentWithChildren } from '../../../types';
import { Dayjs } from 'dayjs';

// TODO: Move to common model file
export interface TimeRange {
  startTime: ITime
  endTime: ITime
}

export interface AvailabilityExceptionItem {
  isAvailable: boolean
  timeRange: {
    startDate: Dayjs
    endDate: Dayjs
  }
}

export interface AvailabilityStepFormData {
  timezone: Timezone
  availability: Record<Weekday, TimeRange[]>
  exceptions: AvailabilityExceptionItem[]
}

const defaultFormData: AvailabilityStepFormData = {
  timezone: Timezone.NEW_YORK,
  availability: {
    [Weekday.MONDAY]: [],
    [Weekday.TUESDAY]: [],
    [Weekday.WEDNESDAY]: [],
    [Weekday.THURSDAY]: [],
    [Weekday.FRIDAY]: [],
    [Weekday.SATURDAY]: [],
    [Weekday.SUNDAY]: []
  },
  exceptions: []
}

const AvailabilityStepContext = React.createContext<IWizardStepContext<AvailabilityStepFormData>>({
  name: StepName.Availability,
  data: defaultFormData,
  setStepData: notYetImplementedWithError,
  validateStepData: notYetImplementedWithError
})

interface AvailabilityStepProviderProps extends ComponentWithChildren {
  initialData?: AvailabilityStepFormData
}

export const AvailabilityStepProvider: React.FC<AvailabilityStepProviderProps> = ({ initialData, children }) => {
  const [data, setStepData] = React.useState<AvailabilityStepFormData>(initialData ?? defaultFormData)

  const value = React.useMemo<IWizardStepContext<AvailabilityStepFormData>>(() => {
    const validateStepData = (): void => {
      if (!data.timezone) {
        throw new Error('Timezone is required')
      }
      const timeslots = Object.values(data.availability).flat()
      timeslots.forEach((timeslot) => {
        if (!timeslot.startTime) {
          throw new Error('Start time is required')
        }
        if (!timeslot.endTime) {
          throw new Error('End time is required')
        }
        if (timeslot.startTime.hour >= timeslot.endTime.hour) {
          throw new Error('Start time must be before end time')
        }
        if (timeslot.startTime.hour === timeslot.endTime.hour && timeslot.startTime.minute >= timeslot.endTime.minute) {
          throw new Error('Start time must be before end time')
        }
      })
    }

    return {
      name: StepName.Availability,
      data,
      setStepData,
      validateStepData
    }
  }, [data])

  return (
    <AvailabilityStepContext.Provider value={value}>
      {children}
    </AvailabilityStepContext.Provider>
  )
}

export default AvailabilityStepContext
